import React from 'react';

import { render } from 'react-dom';

import 'regenerator-runtime/runtime.js';

import { ENVS, getEnv } from '@adsk/acs-sc-web-platform-api';

import App from './App';
import {
  initializeMonitoringHandler,
  initializeMonitoringMetadata,
} from './utils/monitoring';
import { initializeNavigationHandler } from './utils/navigation';
// Register polyfills dynamically
import './polyfills';
import { overrideRemotesOnLocalhost } from './utils/overrideRemotesOnLocalhost';
import {
  initializeTrackingManager,
  appendDynamicPreconnectAndDnsTags,
} from './utils/performance';
import { initializeReactScan } from './utils/reactScan';

const env = getEnv();

if (env !== ENVS.PRODUCTION) {
  overrideRemotesOnLocalhost();
}

appendDynamicPreconnectAndDnsTags();

initializeReactScan();
initializeMonitoringMetadata();
initializeMonitoringHandler();
initializeNavigationHandler();
initializeTrackingManager();

render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
);
